<template>
  <div class="notation-input">
    <label :for="selectId">{{ label }}</label>
    <input
      v-model="idNotation"
      :id="selectId"
      @keyup.enter="submit"
      type="number"
    />
  </div>
</template>

<script>
import { eventBus } from "../util/instances";

export default {
  name: "chart-control-notation",
  props: {
    channel: {
      type: String,
      required: true,
      default: "1"
    },
    config: {
      type: Object,
      required: false,
      default: () => {}
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    idNotation: {
      type: Number,
      required: true
    }
  },
  methods: {
    submit() {
      eventBus.$emit(`${this.channel}:changeNotation`, this.idNotation);
    }
  },
  computed: {
    selectId: function() {
      return "notation-input-" + this.channel;
    }
  }
};
</script>

<style scoped>
.benchmark {
  color: #333;
}
</style>
